<template>
  <div class="box" :class="hasContactInActiveClass">
    <div>
      <div class="columns">
        <div class="column is-12">
          <a class="is-pulled-right" v-if="index && index > 0" @click="onRemoveContactConfirm">
            <i class="has-text-danger fas fa-trash fa-sm"></i>
          </a>
        </div>
      </div>
      <div class="columns is-multiline">
        <div class="column is-12">
          <div class="field">
            <label class="label">First Name<b-icon pack="fas" icon="star" class="fa-ss" v-show="isRequired"></b-icon></label>
            <div class="control">
              <input :name="instanceName + '.firstName'" v-validate="{'required': true, 'max': 150}" :class="{'input': true, 'is-danger': errors.has(validationName + 'firstName') }" :disabled="isInActiveContact" :data-vv-scope="scope" data-vv-as="first name" type="text" placeholder="e.g John" v-model="contact.firstName">
              <span v-show="errors.has(validationName + 'firstName')" class="help is-danger">
                <i v-show="errors.has(validationName + 'firstName')" class="fas fa-exclamation-triangle"></i>{{ errors.first(validationName + 'firstName') }}
              </span>
            </div>
          </div>
        </div>
        <div class="column is-12">
          <div class="field">
            <label class="label">Last Name<b-icon pack="fas" icon="star" class="fa-ss" v-show="isRequired"></b-icon></label>
            <div class="control">
              <input :name="instanceName + '.lastName'" v-validate="{'required': isRequired, 'max': 150}" :class="{'input': true, 'is-danger': errors.has(validationName + 'lastName') }" :disabled="isInActiveContact" :data-vv-scope="scope" data-vv-as="last name" type="text" placeholder="e.g Doe" v-model="contact.lastName">
            </div>
            <span v-show="errors.has(validationName + 'lastName')" class="help is-danger">
              <i v-show="errors.has(validationName + 'lastName')" class="fas fa-exclamation-triangle"></i> {{ errors.first(validationName + 'lastName') }}
            </span>
          </div>
        </div>
      </div>
      <div class="columns is-multiline">
        <div class="column is-12">
          <div class="field">
            <label class="label">Email Address<b-icon pack="fas" icon="star" class="fa-ss" v-show="isRequired"></b-icon></label>
            <div class="control has-icons-right">
              <input :name="instanceName + '.email'" v-validate="{'required': isRequired, 'email': true, 'max': 50}" :class="{'input': true, 'is-danger': errors.has(validationName + 'email') }" :disabled="isInActiveContact" :data-vv-scope="scope" data-vv-as="email address" data-vv-delay="1000" type="text" placeholder="Email" v-model="contact.email">
              <span v-show="errors.has(validationName + 'email')" class="help is-danger">
                <i v-show="errors.has(validationName + 'email')" class="fas fa-exclamation-triangle"></i>{{ errors.first(validationName + 'email') }}
              </span>
              <span class="icon is-small is-right">
                <i class="fal fa-envelope default-blue"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="column is-12">
          <div class="field">
            <label class="label">Mobile</label>
            <div class="control has-icons-right">
              <input :name="instanceName + '.mobile'" v-validate="{'min':16, 'max':16}" :class="{'input': true }" :disabled="isInActiveContact" data-vv-as="mobile" type="tel" placeholder="+1(999)-999-9999" v-mask="'+1(###)-###-####'" v-model="contact.mobile">
              <span v-show="errors.has('mobile')" class="help is-danger">
                <i v-show="errors.has('mobile')" class="fas fa-exclamation-triangle"></i> {{ errors.first('mobile') }}
              </span>
              <span class="icon is-small is-right">
                <i class="fal fa-mobile-android default-blue"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="columns is-multiline">
        <div class="column is-6">
          <button-list-selector :enabled="!isInActiveContact" validateAs="primary contact" :scope="scope" label="Primary Contact" :required="isRequired" v-model="selectedIsPrimary" :availableValues="definedTypes.fillTypes.options"></button-list-selector>
        </div>
        <div class="column is-6">
          <button-list-selector :enabled="!isInActiveContact" v-on:on-change="onBuyersChanged" :scope="scope" validateAs="receives paperwork to buy a car from us" label="Receives paperwork to buy a car from us" :required="isRequired" v-model="selectedReceivesBuyersOrder" :availableValues="definedTypes.fillTypes.options"></button-list-selector>
        </div>
        <div class="column is-6">
          <button-list-selector :enabled="!isInActiveContact" v-on:on-change="onSellersChanged" :scope="scope" validateAs="receives paperwork to sell a car to us" label="Receives paperwork to sell a car to us" :required="isRequired" v-model="selectedReceivesSellersOrder" :availableValues="definedTypes.fillTypes.options"></button-list-selector>
        </div>
        <div class="column is-6">
          <button-list-selector :enabled="!isInActiveContact" validateAs="receives payment &amp; title" :scope="scope" label="Receives Payment &amp; Title" :required="isRequired" v-model="selectedReceivesPaymentAndTitle" :availableValues="definedTypes.fillTypes.options"></button-list-selector>
        </div>
      </div>
      <b-loading :is-full-page="true" :active.sync="showLoader" :canCancel="false"></b-loading>
    </div>
    <b-modal :active.sync="isDeleteConfirmationActive" :width="640" scroll="keep" :has-modal-card="true" v-if="isDeleteConfirmationActive">
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">Confirm Delete Contact</p>
        </header>
        <section class="modal-card-body">
          Are you sure you wish to delete the selected contact ?
        </section>
        <footer class="modal-card-foot">
          <a class="button is-primary" @click="onRemoveContact">Yes</a>
          <a class="button is-danger" @click="isDeleteConfirmationActive = false">No</a>
        </footer>
      </div>
    </b-modal>
  </div>
</template>
<script>

import { createNamespacedHelpers } from 'vuex'
import ButtonListSelector from '@/components/generic/ButtonListSelector'
const mapConfigGetters = createNamespacedHelpers('config').mapGetters

export default {
  inject: {
    $validator: '$validator'
  },
  name: 'ContactCapture',
  props: {
    value: {
      type: Object,
      default: null
    },
    index: {
      type: Number,
      default: 0
    },
    scope: {
      type: String,
      default: null
    },
    getValidationErrors: {
      type: Boolean,
      default: false
    },
    isRequired: {
      type: Boolean,
      default: true
    }
  },
  components: {
    'button-list-selector': ButtonListSelector
  },
  data () {
    return {
      instanceName: this.$uuid.v4(),
      showLoader: false,
      contact: this.value,
      isDeleteConfirmationActive: false,
      selectedActiveStatus: this.value.selectedActiveStatus,
      selectedIsPrimary: this.value.selectedIsPrimary,
      selectedReceivesBuyersOrder: this.value.selectedReceivesBuyersOrder,
      selectedReceivesSellersOrder: this.value.selectedReceivesSellersOrder,
      selectedReceivesPaymentAndTitle: this.value.selectedReceivesPaymentAndTitle
    }
  },
  computed: {
    ...mapConfigGetters(['definedTypes']),
    validationName: function () {
      return (this.scope) ? this.scope + '.' + this.instanceName + '.' : this.instanceName + '.'
    },
    isInActiveContact: function () {
      return this.selectedActiveStatus.name === 'No'
    },
    hasContactInActiveClass: function () {
      return this.isInActiveContact ? 'inactive-contact' : ''
    }
  },
  methods: {
    onRemoveContactConfirm: function () {
      this.isDeleteConfirmationActive = true
    },
    onRemoveContact: function () {
      this.$emit('on-contact-remove', this.contact)
    },
    onBuyersChanged: function (value) {
      if (value !== null && value.name === 'Yes') {
        this.$emit('contactBuyerChanged', this.contact)
      }
    },
    onSellersChanged: function (value) {
      if (value !== null && value.name === 'Yes') {
        this.$emit('contactSellerChanged', this.contact)
      }
    },
    onActiveChanged: function (value) {
      if (value !== null && value.name === 'No') {
        var no = this.definedTypes.fillTypes.options.find(x => x.id === this.definedTypes.fillTypes.No)
        this.selectedIsPrimary = no
        this.selectedReceivesBuyersOrder = no
        this.selectedReceivesSellersOrder = no
        this.selectedReceivesPaymentAndTitle = no
      }
    }
  },
  watch: {
    'value.key': function (newValue, oldValue) {
      this.selectedActiveStatus = this.contact.selectedActiveStatus
      this.selectedIsPrimary = this.contact.selectedIsPrimary
      this.selectedReceivesBuyersOrder = this.contact.selectedReceivesBuyersOrder
      this.selectedReceivesSellersOrder = this.contact.selectedReceivesSellersOrder
      this.selectedReceivesPaymentAndTitle = this.contact.selectedReceivesPaymentAndTitle
      this.$forceUpdate()
    },
    getValidationErrors: function (newValue, oldValue) {
      if (newValue === true) {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.contact.hasValidationErrors = false
            this.contact.canSave = true
          } else {
            this.contact.hasValidationErrors = true
            this.contact.canSave = false
          }
        })
      }
    },
    selectedActiveStatus: function (newValue, oldValue) {
      if (oldValue && newValue) {
        this.contact.selectedActiveStatus = newValue
      }
    },
    selectedIsPrimary: function (newValue, oldValue) {
      if (oldValue && newValue) {
        this.contact.selectedIsPrimary = newValue

        if (oldValue.name === 'Yes') {
          this.$emit('autoSelectPrimaryContact', this.contact)
        }
      }
    },
    selectedReceivesBuyersOrder: function (newValue, oldValue) {
      if (oldValue && newValue) {
        this.contact.selectedReceivesBuyersOrder = newValue
      }
    },
    selectedReceivesSellersOrder: function (newValue, oldValue) {
      if (oldValue && newValue) {
        this.contact.selectedReceivesSellersOrder = newValue
      }
    },
    selectedReceivesPaymentAndTitle: function (newValue, oldValue) {
      if (oldValue && newValue) {
        this.contact.selectedReceivesPaymentAndTitle = newValue
      }
    }
  },
  mounted () {
  }
}
</script>

<style scoped>
  .box {
    background-color: #f6f8fa;
  }

  .inactive-contact {
    opacity: 0.5;
  }

</style>
